// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// required for modal close
// but makes problem with showing calendar when is on
// dodat u a tag ukoliko treba iskljucit turbolinks na neki klick
// data-turbolinks="false"
require("turbolinks").start()

// required for venue like button
require("@rails/ujs").start()


require("@rails/activestorage").start()
require("channels")
// require("flatpickr/dist/themes/airbnb.css")
require("../css/flatpickr.min")

require("datatables.net")
require('datatables.net-bs4')
require("datatables.net-bs4/css/dataTables.bootstrap4.min.css")


require("../js/jquery.easy-autocomplete.min")
require("../packs/search")

// import flatpickr from "flatpickr";
var flatpickr = require("../js/flatpickr")
global.$ = global.flatpickr = flatpickr;
window.$ = window.flatpickr = flatpickr;

import ColorThief from '../js/color-thief.umd'
import "../css/public_layout.scss";

// import Swiper from "swiper";
var Swiper = require("../js/swiper-bundle.min")
global.$ = global.Swiper = Swiper;
window.$ = window.Swiper = Swiper;

var jQuery = require('jquery')

global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;
import "bootstrap"



// import flatpickr from "flatpickr";

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

const colorThief = new ColorThief();



$(function() {

    // $(".datepicker").flatpickr( {
    //     enableTime: true,
    //     format: 'mm/dd/yyyy',
    //     defaultDate: "today",
    // });

    var img = document.querySelector('.venue_featured_image');

    var dominantColor;
    
    // Make sure image is finished loading
    if (img !== null && img.complete) {
        dominantColor = colorThief.getColor(img);
    } else if (img !== null) {
        img.addEventListener('load', function() {
            dominantColor = colorThief.getColor(img);
        });
    }

    var gradient_container = document.querySelector('.gradient-container');
    
    if(gradient_container && dominantColor){
        $(gradient_container).css({'background-image': `linear-gradient(180deg, rgba(${dominantColor.join()},.9), rgba(255,0,0,0) 100%)`,'height':'600px','padding-top':'2rem'});
    }



});